import{required as r}from"vuelidate/lib/validators";var e=function(){return{ticket:{required:r},passenger:{required:r}}};export{e as ticketValidator};
